module.exports = "<audio controls=\"\" controlslist=nodownload style=width:100%> <source ng-src={{musicUrl}} type=audio/mpeg> </audio>";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/practicalExample/js/music/music.html
// module id = 1129
// module chunks = 0